<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Classe: </span>
      <span>{{classe.descricao}}</span>
    </div>
  </ng-template>

  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{classe.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Descrição: </label>
      <div class="p-col-12 p-md-10">{{classe.descricao}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Grupo procedimento: </label>
      <div class="p-col-12 p-md-10">{{classe.grupoProcedimento | dominio: 'getGrupoProcedimento'}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Tipo procedimento: </label>
      <div class="p-col-12 p-md-10"> {{classe.tipoProcedimento | dominio: 'getTipoProcedimento'}} </div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Situação: </label>
      <div class="p-col-12 p-md-10" *ngIf="classe?.situacao === 'ATIVO'" class="badge badge-success m-l-8">Ativo</div>
      <div class="p-col-12 p-md-10" *ngIf="classe?.situacao === 'INATIVO'" class="badge badge-danger m-l-8">Inativo</div>
    </div>
    <div class="p-field p-grid" *ngIf="classeHierarquia">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Hierarquia: </label>
      <div class="p-col-12 p-md-10">
        <span  *ngIf="classeHierarquia.length > 0">
        <span *ngFor="let classeHierarquia of classeHierarquia">
          <a (click)="this.limparHierarquia()" [routerLink]="['/classe/visualizar', classeHierarquia.id]">
            {{replaceTextoHierarquia(classeHierarquia.descricao)}}/
          </a>
        </span>
      </span>
        {{classe.descricao}}
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>
